/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Scope_Detail5Inputs */

const en_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit the build: what is broken, what is risky, what blocks launch.`)
};

const ar_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دقق البناء: ما المعطل وما المحفوف بالمخاطر وما يحجب الإطلاق.`)
};

const bn_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিল্ড অডিট করুন: কী ভাঙা, কী ঝুঁকিপূর্ণ, লঞ্চে কী বাধা।`)
};

const de_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit des Builds: was kaputt ist, was riskant ist, was den Start blockiert.`)
};

const es_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditar el desarrollo: qué está roto, qué es arriesgado, qué bloquea el lanzamiento.`)
};

const fr_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditez le build : ce qui est cassé, ce qui est risqué, ce qui bloque le lancement.`)
};

const pt_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audite o desenvolvimento: o que está partido, o que é arriscado, o que bloqueia o lançamento.`)
};

const zh_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审计这个构建：哪里坏了、哪里有风险、哪里挡住上线。`)
};

const tr_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derlemeyi denetleyin: ne bozuk, ne riskli, lansmanı ne engelliyor.`)
};

const ru_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудит сборки: что сломано, что рискованно, что блокирует запуск.`)
};

const pl_svc_ai_app_rescue_scope_detail5 = /** @type {(inputs: Svc_Ai_App_Rescue_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audyt buildu: co zepsute, co ryzykowne, co blokuje start.`)
};

/**
* | output |
* | --- |
* | "Audit the build: what is broken, what is risky, what blocks launch." |
*
* @param {Svc_Ai_App_Rescue_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_scope_detail5 = /** @type {((inputs?: Svc_Ai_App_Rescue_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_scope_detail5(inputs)
	return en_svc_ai_app_rescue_scope_detail5(inputs)
});
export { svc_ai_app_rescue_scope_detail5 as "svc_ai-app-rescue_SCOPE_detail" }